import { render } from "./ThreadEditor.vue?vue&type=template&id=0103a24e"
import script from "./ThreadEditor.vue?vue&type=script&lang=js"
export * from "./ThreadEditor.vue?vue&type=script&lang=js"
script.render = render

export default script